import styled from "styled-components";

const AddKeywordStyles = styled.div`
  .keywordsSection {
    border-right: 1px solid #dbdbdb;
    margin: -24px 0px;
  }

  .icon {
    margin-right: 5px;
  }

  .sitesSection {
    margin-top: -24px;
  }

  .sectionHeading {
    display: flex;
    font-size: 16px;
    border-bottom: 1px solid #dbdbdb;
    margin: 15px -25px;
    padding-left: 25px;
    padding-bottom: 10px;

    .tag {
      width: 25px;
      height: 25px;
      background: #02a2f2;
      color: #ffffff;
      font-weight: 600;
      margin-right: 10px;
      border-radius: 20px;
      text-align: center;
      padding: 0px 8.5px;
    }

    .headingText {
      color: #15151f;
    }
  }

  .selectedKeywordContainer {
    margin: 15px 0px;

    .selected {
      display: flex;
      border: 1px solid #dbdbdb;
      padding: 5px 10px;
    }

    .selectedSearchEngine {
      border-top-right-radius: 4px;
      border-top-left-radius: 4px;
    }

    .selectedCountry {
      border-bottom-right-radius: 4px;
      border-bottom-left-radius: 4px;
    }
  }

  .image {
    width: 20px;
    height: 20px;
    margin-right: 10px;
  }

  .addButton {
    background-color: #3e617c;
    border: 1px solid #3e617c;
  }
`;

export default AddKeywordStyles;
